import React from 'react';

class Footer extends React.Component {

  render() {
    return (
        <div className="layout-footer grid justify-center align-items-center grid-nogutter">
          <div className="col">
            &copy; TransEco2 2025
          </div>
        </div>
    )
  }
}

export default Footer;
